import { Clock, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT } from "../lib/site";

const REGIONS = ["United States", "Canada", "United Kingdom", "Australia"];

const Trust = () => (
  <section className="border-y border-slate-200 bg-white py-16 sm:py-20">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex justify-center">
        <Reveal delay={0.1}>
          <div data-testid="trust-badge-regional-seals" className="flex flex-col items-center gap-4">
            <p className="flex items-center gap-2 text-sm text-slate-600">
              <Clock className="h-4 w-4 text-[#2E3192]" />
              {CONTACT.hoursLine}
            </p>
            <div className="flex flex-wrap gap-2">
              {REGIONS.map((r) => (
                <span
                  key={r}
                  className="flex items-center gap-1.5 rounded-full border border-slate-200 px-3 py-1 font-mono2 text-[10px] uppercase tracking-[0.18em] text-slate-500"
                >
                  <MapPin className="h-3 w-3 text-[#2E3192]" />
                  {r}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Trust;
